<template>
  <component :is="icon" />
</template>

<script>
const iconNameMap = {
  1: require('../present'),
  2: require('../cake'),
  3: require('../TelIcon').default,
  4: require('../mailInverse'),
  5: require('../exclamation'),
  6: require('../lock'),
  7: require('../car'),
  8: require('../smile'),
  9: require('../NoSmokeIcon').default,
  10: require('../beer'),
  11: require('../point'),
  12: require('../coupon'),
  13: require('../tired'),
  14: require('../heart'),
  15: require('../star'),
  16: require('../bottle'),
  17: require('../off'),
  18: require('../customer'),
  19: require('../clock'),
  20: require('../baby'),
  21: require('../child'),
  22: require('../unhappy'),
  23: require('../anger'),
  24: require('../bag'),
  25: require('../global'),
  26: require('../koshitsu'),
  27: require('../hankoshitsu'),
  28: require('../circle'),
  29: require('../triangle'),
  30: require('../cross'),
}

/**
 * 予約タグアイコン
 *
 * 指定された id のアイコンを表示します。
 */
export default {
  name: 'TagIcon',
  props: {
    /** 予約タグアイコンID */
    id: { type: Number, required: true },
  },
  computed: {
    icon() {
      return iconNameMap[this.id]
    },
  },
}
</script>
